/* globals $: true, window: true, INSTANT_URL: true, Codsec: true, PUBLIC_API_SERVER: true, USER_UUID: true, executeDelete: true, executePost: true, executeGet: true */

$(function() {
	//For loading initial list of results for specified package
	$('#app-list-container').on('click', '.app-link', function(e) {
		e.preventDefault();

		var pkg = $(this).data('package'),
			platform = $(this).data('platform'),
			app = {
				title    : $(this).find('h3').text(),
				package  : pkg,
				platform : platform
			},
			url = '/user/app/' + platform + '/' + pkg + '/results?limit=5&useIgnore=1';


		if(!pkg || !platform) {
			$('#result-container').html(Codsec.templates.dashboard.scanResults({
				scans      : [],
				app        : app,
				totalCount : 0,
				instantUrl : INSTANT_URL
			}));

			return;
		}

		executeGet(url)
			.done(function (data) {
				var viewOptions = {
					currentUser : CURRENT_USER,
					scans       : data.results,
					totalCount  : data.totalCount,
					app         : app,
					package     : pkg,
					platform    : platform
				};

				Codsec.reloader.mightReloadScans(data.results, url, viewOptions);

				var html = Codsec.templates.dashboard.scanResults(viewOptions);

				$('#result-container').html(html);
			})
			.fail(function(error) {
				//@TODO display error
			});
	});

	//For loading more content for single package
	$('#result-container').on('click', '#show-all-results', function(e) {
		e.preventDefault();

		var pkg = $(this).data('package'),
			platform = $(this).data('platform'),
			viewOptions = {
				totalCount : 0,
				app        : {
					title    : $(this).data('app_title'),
					package  : pkg,
					platform : platform
				},
				package     : pkg,
				platform    : platform,
				currentUser : CURRENT_USER,
			}, url = '/user/app/' + platform + '/' + pkg + '/results?useIgnore=1';

		executeGet(url)
			.done(function(data) {
				viewOptions.scans = data.results;

				Codsec.reloader.mightReloadScans(data.results, url, viewOptions);

				var html = Codsec.templates.dashboard.scanResults(viewOptions);
				$('#result-container').html(html);
			})
			.fail(function(error) {
				//@TODO display error
			});
	});

	//for loading complete list of all scans
	$('#result-container').on('click', '#load-all-scan-results', function(e) {
		e.preventDefault();

		var viewOptions = {
			totalCount : 0
		};

		executeGet('/user/results?useIgnore=1')
			.done(function(data) {
				viewOptions.scans = data.results;

				Codsec.reloader.mightReloadScans(data.results, '/user/results?useIgnore=1', viewOptions);

				var html = Codsec.templates.dashboard.scanResults(viewOptions);

				$('#result-container').html(html);
			})
			.fail(function(error) {
				//@TODO display error
			});
	});

	//For results in scan result list that don't have result link yet
	//a tag is necessary as otherwise styling breaks
	$('#result-container').on('click', '.no-result-link', function(e) {
		e.preventDefault();
	});

	$(window).bind('beforeunload', function(){
		if($('.app-add-options:visible .binary-upload-progress').attr('data-percentage')) {
			var $curper = $('.app-add-options:visible .binary-upload-progress').attr('data-percentage');
			if($curper != '100%') {
				return 'Your file is still uploading. It\'s currently at ' + $curper + '.';
			}
		}
	});

	$('#delete-application-button').on('click', function(e) {
		e.preventDefault();

		if(confirm('Are you sure?')) {
			executeDelete('/user/app/' + $(this).data('platform') + '/' + $(this).data('package'))
				.done(function() {
					window.location.href = '/';
				})
				.fail(function() {
					//@TODO display some sort of error
				});
		}
	});
});
